// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4221":"e73be37f","5971":"2de62c34","7684":"a88f1c6f","7850":"329f6c5e"}[chunkId] + ".chunk.css";
};